import type { IBrandConfig } from './types';

const PARTYHAT_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: 'https://www.getpartyhat.com/privacy',
  termsOfService: 'https://www.getpartyhat.com/terms',
  vaultProject: 'partyhat',
  adaChat: true,
  accountDetails: false,
  secureUpload: false,
  plan: false,
  security: false,
  missingPII: false,
  finishSetup: false,
  darkwebDashboardCard: true,
  defaultBillingCategoryKey: 'privacy_breach',
  downloadsRecommended: false,
  copyRightText: 'Partyhat Inc. All rights reserved.',
  hasCustomerServiceSupport: true,
  horizontalVaultDashboardCards: false,
  ssoRedirectURL: 'https://www.getpartyhat.com',
  dwEmailVerification: {
    adaChat: false,
    signInButton: false,
    supportAt: 'support@getpartyhat.com',
    availability: null,
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    customerSupportTitle: {
      active: false,
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      active: false,
    },
    mail: {
      active: false,
    },
    email: {
      active: true,
      address: 'support@getpartyhat.com',
      customerSupport: true,
    },
  },
};

export default PARTYHAT_BRAND_CONFIG;
